<template>
  <div>
    <div class="core-enterprise">
     <BWSelect
        placeholder="请选择"
        label="核心企业名称"
        model="coreEnterpriseTaxNo"
        :columnsTerm="coreEnterprise"
      />
      <Input
        class="temr"
        placeholder=""
        v-bind:value="curCoreCode"
        labelWidth="110px"
        :readonly="true"
        label="核心企业税号"
      />
      <div class="tips">
        <p>提示：</p>
        <p>选择合适的核心企业有助于提高您的授信额度，请选择您合作关系中实力最强、贸易往来最为密切的核心企业。</p>
      </div>
      <Button :text="text" :type="danger" :loading="isLoading" :disabled="canGoNext" loadingText="提交中..." :class="canGoNext ? 'next-gray' : 'next'" :click="onSubmit" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Input from '@/components/Input.vue';
import BWSelect from '../../commonPage/components/BWSelect.vue';
import Button from '@/components/Button.vue';
import { Toast } from 'vant';

export default {
  name: 'taxEmpower',
  components: {
    Input,
    BWSelect,
    Button
  },
  data() {
    return {
      titleImg: require('@/assets/images/waiting_ico.png'),
      text: '下一步',
      danger: 'danger',
      isLoading: false,
      coreEnterprise: [],
    };
  },
  computed: {
    curCoreCode() {
      return this.$store.state.commonForms.coreEnterpriseTaxNo;
    },
    canGoNext() {
      return this.curCoreCode && !this.isLoading ? false : true;
    }
  },
  mounted() {
    this.enterpriseInfo();
  },
  methods: {
    ...mapActions('commonForms', ['getModel']),
    async enterpriseInfo() {
      try {
        const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo(
          {
            orderId: this.$route.query.orderId,
	          pageId: this.$route.query.pageId
          },
        );
        if (success) {
          this.coreEnterprise = data.coreEnterprise;
        } else {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('接口异常');
      }
    },
    async onSubmit() {
      this.isLoading = true;
        try {
        const { success, returnMessage } = await this.$api.OtherPage.commitApply(
          {
            orderId: this.$route.query.orderId,
            pageId: this.$route.query.pageId,
            coreCorpTaxNo: this.$store.state.commonForms.coreEnterpriseTaxNo,
            coreCorpName: this.$store.state.commonForms.coreEnterpriseTaxNoText
          },
        );
        if (success) {
          this.getModel();
        } else {
          this.isLoading = false;
          Toast(returnMessage);
        }
      } catch (e) {
        this.isLoading = false;
        Toast('接口异常');
      }
    },
  },
};
</script>
<style scoped>
.core-enterprise {
  height: 100vh;
  padding-top: 30%;
  background: #fff;
}
.core-enterprise >>> .van-field__label span {
  color: #1c2438;
}
.core-enterprise .tips {
  font-size: 12px;
  text-align: left;
  padding: 20px 16px;
  line-height: 18px;
}
.core-enterprise .tips p {
  margin: 0;
}
.core-enterprise .temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.next >>> .van-button {
  box-shadow: 0px 12px 12px -10px #ff6538;
  border: 0;
  margin-top: 20px;
  transition: 0.7s;
}

.next-gray >>> .van-button {
  box-shadow: 0px 12px 12px -10px #7691a3;
  border: 0;
  margin-top: 20px;
  transition: 0.7s;
}
</style>
